import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { DataService } from '../../services/data.service';
import * as LandingPageActions from '../actions/landing-page.actions';

@Injectable()
export class LandingPageExtendedEffects {
  protected readonly actions$ = inject(Actions);
  protected readonly data = inject(DataService);
  protected readonly store = inject(Store);

  loadBusinessTravelerFeatureFlagContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandingPageActions.loadBusinessTravelerFeatureFlagContent),
      take(1),
      switchMap(() =>
        this.data.getBusinessTravelerFeatureFlagAEMContent().pipe(
          map((content) => {
            if (content) {
              this.store.dispatch(
                LandingPageActions.loadBusinessTravelerContent()
              );
            }
            return LandingPageActions.loadBusinessTravelerFeatureFlagSuccess({
              aemBusinessTravelerFeatureFlag: {
                id: 'business-traveler-feature-flag-content',
                aemBusinessTravelerFeatureFlag: content
              }
            });
          }),
          catchError(() =>
            of(
              LandingPageActions.loadBusinessTravelerFeatureFlagFailure({
                aemBusinessTravelerFeatureFlagError: {
                  id: 'business-traveler-feature-flag-content-error',
                  aemBusinessTravelerFeatureFlagError: false
                }
              })
            )
          )
        )
      )
    )
  );

  loadBusinessTravelerContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandingPageActions.loadBusinessTravelerContent),
      take(1),
      switchMap(() =>
        this.data.getBusinessTravelerContent().pipe(
          map((content) =>
            LandingPageActions.loadBusinessTravelerContentSuccess({
              businessTraveler: {
                id: 'business-traveler-content',
                businessTraveler: content
              }
            })
          ),
          catchError(() =>
            of(
              LandingPageActions.loadBusinessTravelerContentFailure({
                businessTravelerError: {
                  id: 'business-traveler-content-error',
                  businessTravelerError: false
                }
              })
            )
          )
        )
      )
    )
  );
}
